import { Schema } from "@effect/schema";
import { ProtocolKey } from "./protocol";
import { ChainKey } from "./chain";
import { Address } from "./address";
import { Usd } from "./usd";
import { DashboardMarket } from "./market/dashboard-market";

export type DashboardData = typeof DashboardData.Type;
export type DashboardDataEncoded = typeof DashboardData.Encoded;

export const DashboardData = Schema.Struct({
  data: Schema.Struct({
    protocolKey: ProtocolKey,
    chainKey: ChainKey,
    user: Address,
    depositBalanceUsd: Usd,
    debtBalanceUsd: Usd,
    dashboardMarkets: Schema.Array(DashboardMarket),
  }),
}).annotations({ identifier: "DashboardData" });
